// Workflow Index Route - Resets workflow and redirects to summary step
import { createFileRoute, redirect } from '@tanstack/react-router';

// Storage keys used by WorkflowContext
const STORAGE_KEY = 'creditnova_workflow_data';
const STEP_STORAGE_KEY = 'creditnova_workflow_step';
const COMPLETED_STORAGE_KEY = 'creditnova_workflow_completed';

export const Route = createFileRoute('/workflow/')({
  beforeLoad: () => {
    // Clear any existing workflow state to start fresh (sessionStorage = per-tab)
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STEP_STORAGE_KEY);
      sessionStorage.removeItem(COMPLETED_STORAGE_KEY);
    }
    throw redirect({ to: '/workflow/summary' });
  },
  component: () => null,
});
